// import mixpanel from 'mixpanel-browser';
// import { MIXPANEL_TOKEN, MIXPANEL_DEBUG} from '../constants';
import { useUserStore } from '../store/userStore';
import { useMyLeagueStore } from '../store/myLeagueStore';

/**
  what we track:

  generic call
       type: page or event
       action: see below
       details:  { environment: domain, app_page: page, user: userId, league: leagueId, team: teamId, description, event_detail: details, value: gaValue })

  Pages
      supposed to be handled in header.. will check

  Events
    type: event
    action: <Page/Modal>-<Action/State>-<optional detail>
    environment: local/stage/prod
    app_page: window.location.pathname
    user: userId
    team: teamId
    league: leagueId
    description: optional
    event_details: optional
    event_value: optional number

    valid actions:
    PlayerCard-Open-My_Player
    PlayerCard-Open-Other_Team_Player
    PlayerCard-Open-Free_Agent
    PlayerCard-Open-Waived_Player
    PlayerCard-<click action>-My_Player
    PlayerCard-<click action>-Other_Team_Player
    PlayerCard-<click action>-Free_Agent
    PlayerCard-<click action>-Waived_Player

    TradeModal-Open-Start
    TradeModal-Open-ViewOnly
    TradeModal-Open-My_Trade (this means I'm looking at a trade where I'm the last one who's changed it)
    TradeModal-Proposed (if there's a note, it's in the details as "includes note")
    TradeModal-Updated (this is for a team updating the last proposal/counter)
    TradeModal-Countered
    TradeModal-View-Proposal (if viewing a proposal/counter)
    TradeModal-Withdrawn
    TradeModal-Declined
    TradeModal-Rejected

    Roster-Open
    Roster-Tab-<tab name>
    Roster-ChangeTo-Other_Team
    Roster-ChangeTo-My_Team

    MyTrades-Open
    MyTrades-Tab-<tab name>

    Players-Filter (details in the event_details)

    FreeAgents-Switch-<All/Accepting_Offers>
    FreeAgents-Filter (details in the event_details)

    FreeAgentOffer-Open
    FreeAgentOffer-Submitted (details include which offer # this is for this player)

    WaiverWire-Filter (details in the event_details)
    WaiverWire-Claim (details include which # claim this is for this player)

    SwitchTeam-Dashboard
    SwitchTeam-TopNav

    Chat-Open
    Chat-Close
    Chat-New
    Chat-DM (a message to an existing single person message room)
    Chat-Group (a message to an existing multi-person message room)

    Notifications-Open
    Notifications-Click

    ContactUs-Open
    ContactUs-Submitted

    Terms-Open
    Privacy-Open
    SMSPolicy-Open

    Dashboard-Open (if from navigation or breadcrums)

    SignIn-Open
    SignIn-Fail
    SignIn-2FA-Fail
    SignIn-Success
    SignOut
    Register-Open
    Register-Fail
    Register-Success

    ForgotPassword-Open
    ForgotPassword-Submit

    JoinLeague-PurchaseTeam
    JoinLeague-JoinRequest

    Profile-Tab-<tab name>
    Profile-Update (details in event details)
    Invite-<Role> ("highest role.. other roles in event details")
    JoinRequest-Accept
    JoinRequest-Decline

    TeamMember-Update-Ownership
    TeamMember-Update-Roles
    TeamMember-Remove


 */
export default function eventTracking(
  page,
  action,
  description = '',
  details = '',
  value = 0,
) {
  // Get user data from zustand stores (can be called outside React components)
  const user = useUserStore.getState().user;
  const myLeague = useMyLeagueStore.getState().myLeague;
  
  // Early return if no user
  if (!user) {
    return;
  }

  // Get user ID and role
  const userId = user.id || localStorage.getItem('userId');
  const userRoleString = user.role || localStorage.getItem('userRole') || 'visitor';
  const roles = Array.isArray(userRoleString) ? userRoleString : [userRoleString];
  const isImpersonated = false;
  
  // Skip tracking for admins
  if (roles.some(role => role.includes('admin')) || isImpersonated) {
    return;
  }
  
  let userRole = 'unknown';
  if (roles.some(role => role.includes('admin') || role.includes('superadmin'))) {
    userRole = 'admin';
  } else if (roles.some(role => role.includes('agent'))) {
    userRole = 'member';
  } else if (roles.some(role => role.includes('concierge') || role.includes('realmAdmin'))) {
    userRole = 'MET';
  } else if (roles.some(role => role.includes('qa'))) {
    userRole = 'QA';
  }

  // mixpanel init
  // Enabling the debug mode flag is useful during implementation,
  // but it's recommended you remove it for production
  // const mpt = MIXPANEL_TOKEN;
  // mixpanel.init(mpt, { 
  //   opt_out_tracking_by_default: false, 
  //   debug: MIXPANEL_DEBUG,
  // });
  // const optOut = mixpanel.has_opted_out_tracking();

  const urlParts = document.URL.split('//');
  const domainParts = urlParts[1].split('/');
  const domain = `${domainParts[0]
    .replace(':5043', '')
    .replace('.dominusbaseball', '')
    .replace('beta', 'beta')}`;
  const pageWithId = `${domain}-${page}-${userId}`;
  const leagueId = myLeague?.id || null;
  const teamId = user.user_data?.myTeam || null;

  const gaValue = action !== 'SignIn' ? value : 9999;
  const gaAction = description ? `${action}-${description} ${details}` : action;
  //send a gtag event for google analytics 
  gtag('event', action, { environment: domain, page: page, user: userId, league: leagueId, team: teamId, description, event_detail: details, value: gaValue });

  // mixpanel event

// mixpanel.opt_in_tracking();
  // if (me && action === 'Sign In') {
  //   mixpanel.identify(userId)
  // }

  // mixpanel.track(action, {
  //   environment: domain,
  //   page,
  //   userId,
  //   role: userRole,
  //   description,
  //   details,
  //   value,
  // }
  // );
}
